import { connect } from "react-redux";

export default (getEventId) => (Component) => {
  const mapStateToProps = (state, ownProps) => {
    if (ownProps?.isContestCard) {
      const wsReadyState = state?.liveReducer?.connected ?? false;
      if (wsReadyState !== 1) {
        return {
          live: undefined,
        };
      }
      return {
        live: state?.liveReducer?.byContestIds?.[getEventId(ownProps)],
      };
    } else {
      const wsReadyState = state?.liveReducer?.connected ?? false;
      if (wsReadyState !== 1) {
        return {
          live: undefined,
        };
      }
      return {
        live: state?.liveReducer?.byIds?.[getEventId(ownProps)],
      };
    }
  };
  return connect(mapStateToProps, null)(Component);
};
